import { Container, FormGroup, Skeleton } from "@mui/material"
import { Account } from "../../apis/ersys-data/api"
import { Control } from "react-hook-form"
import FormInputTextArea from "../forms/FormInputTextArea"

interface AccountCommentsTabProps {
    control: Control<Account, any>
    showSkeleton: () => boolean,
    formSpacing: number
}

const AccountCommentsTab: React.FC<AccountCommentsTabProps> = ({ control, showSkeleton, formSpacing }) => {

    const renderSkeleton = () => {
        return (
            <FormGroup sx={{width: "100%"}}>
                <Skeleton variant='rectangular' width={800} height={200} sx={{ margin: 2 }} key="comments-skele"/>
            </FormGroup>
        )
    }

    return (
        <Container>
            {showSkeleton() ? renderSkeleton() :
                <FormGroup>
                    <FormInputTextArea 
                        rows={12}
                        whitespace="pre-wrap"
                        control={control}
                        label="Comments"
                        name="comments"
                        spacing={formSpacing}
                    />
                </FormGroup>}
                </Container>
    )
}

export default AccountCommentsTab